import {http, httpCustom} from '../../../services/config';

export default {
    blocksListAvailableAction ({commit, dispatch}, {allotmentId }) {
        console.log(allotmentId)
        httpCustom.get('api/v1/lotes/quadras/listarDisponiveis', {headers: {'allotment-id': allotmentId}}).then(resp => {
            if (resp.data.length){
                resp.data[0].active = true;
                dispatch('showLotPropertiesAvailableAction', {
                    allotmentId:allotmentId,
                    blockId:resp.data[0].text,
                    withInfos: true
                });
            }
            commit('blocksAvailableMutation', resp.data);
        }).catch(() => {
            commit('blocksAvailableMutation', []);
        })
    },
    blocksListAvailableResumAction ({commit}, {allotmentId }) {
        console.log(allotmentId)
        httpCustom.get('api/v1/lotes/quadras/listarDisponiveis/resume', {headers: {'allotment-id': allotmentId}}).then(resp => {
            commit('blocksAvailableResumeMutation', resp.data);
        }).catch(() => {
            commit('blocksAvailableResumeMutation', []);
        })
    },
    showByTaxpayer: (context, taxpayer) => {
        return http.get('api/v1/clientes/ver/' + taxpayer);
    },
    showLotPropertiesAvailableAction: ({commit},{
        allotmentId = sessionStorage.getItem('allotmentIdScope'),
        blockId, withInfos = null, withLoad = false}) => {
        if (withLoad) commit('changeLoading', true);
        httpCustom.get(`api/v1/lotes/verDisponiveis/${allotmentId}/${blockId}`,{params:{withInfos}}).then((resp =>{
            commit('showLotPropertiesAvailableMutation', resp.data);
        })).catch(() => {
            commit('showLotPropertiesAvailableMutation', []);
        }).finally(() => {
            if (withLoad) commit('changeLoading', false);
        });
    },
    createClientAction: (context, client) => {
        return http.post('api/v1/clientes', client);
    },
    getPermissionsAllotmentAction: ({commit}, {allotmentId}) => {
         http.get(`api/v1/loteamentos/${allotmentId}`, {params:{toCreateReserve:true}}).then((resp) =>{
             commit('getPermissionsAllotmentMutation', resp.data)
         });
    },
}
